/**
 * Namespaces to avoid conflicts on the context.
 */
export const jss = '64a55d578f856d258dc345b094a2a2b3'
export const sheetsRegistry = 'd4bd0baacbc52bbd48bbb9eb24344ecd'
export const providerId = 'd9f144a51454eae08eb84ab3ade674a5'
export const managers = 'b768b78919504fba9de2c03545c5cd3a'
export const sheetOptions = '6fc570d6bd61383819d0f9e7407c452d'



// WEBPACK FOOTER //
// ./src/ns.js